import type { CAMELIZED_FEATURES } from 'constants/features';
import type { RootState } from 'reducers/types';

type Features = (typeof CAMELIZED_FEATURES)[number];

export const getFeatures = (state: RootState) => {
  const { features = {} } = state;

  return features;
};

export const getFeature = (state: RootState, feature: Features) => {
  const features = getFeatures(state);

  // biome-ignore lint/suspicious/noPrototypeBuiltins: false positive
  return Object.prototype.hasOwnProperty.call(features, feature)
    ? features[feature]
    : false;
};
